import {
    openBookingDashboardRouteHandler,
    openBookingComposeRouteHandler,
    editBookingMeetingRouteHandler,
    openBookingPageRouteHandler,
    openMeetingTypePageRouteHandler,
    openMeetingDetailsPageRouteHandler,
} from './bookWithMeRouteHandlers';
import type { RegisterRouteFunction, RouterOptions } from 'owa-router';
import getCurrentRoute from './getCurrentRoute';
import {
    ORGANIZER_PAGE_KEYWORD,
    MEETING_TYPE_ROUTE_KEYWORD,
    ORGANIZER_NEW_MEETING_TYPE_ROUTE_KEYWORD,
    ATTENDEE_PAGE_KEYWORD,
    ATTENDEE_MEETING_DETAILS_ROUTE_KEYWORD,
} from 'bookwithme-shared/lib/store/schema/BookWithMeRouteConstants';
const BOOK_WITH_ME_APP_NAME = 'bookwithme';

export const routerOptions: RouterOptions = {
    routeGenerator: Promise.resolve(getCurrentRoute),
    vdir: BOOK_WITH_ME_APP_NAME,
    defaultRoute: `/${ORGANIZER_PAGE_KEYWORD}`,
    registerRoutes: initializeRoutes,
};

function initializeRoutes(registerBookWithMeRoute: RegisterRouteFunction) {
    /**
     * Path: /
     * Redirects to /home/discover
     */
    registerBookWithMeRoute('/', openBookingDashboardRouteHandler);

    /**
     * Path: /me
     */
    registerBookWithMeRoute(`/${ORGANIZER_PAGE_KEYWORD}`, openBookingDashboardRouteHandler);

    /**
     * Path  me/meetingtype/new
     */
    registerBookWithMeRoute(
        `/${ORGANIZER_PAGE_KEYWORD}/${MEETING_TYPE_ROUTE_KEYWORD}/${ORGANIZER_NEW_MEETING_TYPE_ROUTE_KEYWORD}`,
        openBookingComposeRouteHandler
    );

    /**
     * Path: me/meetingtype/:meetingTypeId
     * Required parameters: meetingTypeId
     */
    registerBookWithMeRoute(
        `/${ORGANIZER_PAGE_KEYWORD}/${MEETING_TYPE_ROUTE_KEYWORD}/:meetingTypeId`,
        editBookingMeetingRouteHandler
    );

    /**
     * Path /page/:bookingMailbox
     * Required parameters: bookingMailbox
     */
    registerBookWithMeRoute(
        `/${ATTENDEE_PAGE_KEYWORD}/:bookingMailbox`,
        openBookingPageRouteHandler
    );

    /**
     * Path /page/:bookingMailbox/event/:bookingId
     * Required parameters: bookingMailbox, bookingId
     */
    registerBookWithMeRoute(
        `/${ATTENDEE_PAGE_KEYWORD}/:bookingMailbox/${ATTENDEE_MEETING_DETAILS_ROUTE_KEYWORD}/:bookingId`,
        openMeetingDetailsPageRouteHandler
    );

    /**
     * Path /page/:bookingMailbox/meetingtype/:meetingTypeId
     * Required parameters: bookingMailbox, meetingTypeId
     */
    registerBookWithMeRoute(
        `/${ATTENDEE_PAGE_KEYWORD}/:bookingMailbox/${MEETING_TYPE_ROUTE_KEYWORD}/:meetingTypeId`,
        openMeetingTypePageRouteHandler
    );

    return Promise.resolve();
}
